module.exports = __webpack_public_path__ + "static/media/phone-rotate-portrait.f0c05b1f.svg";